import React from 'react'

function WebSiteCell(data) {
    if(!data) return
  return (
    <a href={data?.webSitew}>{data?.webSite}</a>
  )
}

export default WebSiteCell